import { Close, LinkTwoTone } from '@material-ui/icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getMembersByName } from '../../../../../../services/formCombos.service';
import AddButton from '../../../../../Common/AddButton';
import { Select } from '../../../../../Common/Select';
import { ActionButton, ActionButtonsContainer, AddParticipantContainer, CardTitle, Container, ParticipantBox, ParticipantLink, ParticipantListContainer, ParticipantName, SelectContainer } from './styles';


interface IParticipantsProps {
    participants: {
        id: string;
        name: string;
    }[];
    setParticipants: React.Dispatch<React.SetStateAction<{
        id: string;
        name: string;
    }[]>>
}

const ParticipantsCard: React.FC<IParticipantsProps> = ({ participants, setParticipants }) => {
    const { t } = useTranslation();

    const [selectedParticipant, setSelectedParticipant] = useState<{ id: string; name: string }>({} as { id: string; name: string });
    const [participantNameToSearch, setParticipantNameToSearch] = useState<string>('');
    const [participantOptions, setParticipantOptions] = useState<{ id: string; name: string }[]>([]);

    useEffect(() => {
        if (participantNameToSearch?.length >= 3) {
            const delayDebounceFn = setTimeout(() => {
                getMembersByName("pt", participantNameToSearch).then(res => {
                if (res.error?.length > 0 || !res?.data) {
                    setParticipantOptions([]);

                    return;
                }

                const responseData = res.data as [];

                const usersNotSelected = responseData.filter((user: any) => !participants.some((participant) => participant.id === user.id));

                setParticipantOptions(usersNotSelected);
            });
        }, 1000)

        return () => clearTimeout(delayDebounceFn)
        } else {
            setParticipantOptions([]);
        }
    }, [participantNameToSearch]);

    const handleAddParticipant = useCallback(() => {
        setParticipants(oldValue => [...oldValue, {
            id: selectedParticipant.id,
            name: participantNameToSearch,
        }]);

        setSelectedParticipant({} as { id: string; name: string });
        setParticipantNameToSearch('');
    }, [selectedParticipant, participantNameToSearch]);

    const handleRemoveParticipant = useCallback((participantId: string) => {
        setParticipants(oldValue => oldValue.filter(participant => participant.id !== participantId));        
    }, []);

    return (
        <Container>
            <CardTitle>Participants</CardTitle>

            <AddParticipantContainer>
                <SelectContainer>
                    <Select
                        id="Participant"
                        options={participantOptions}
                        value={selectedParticipant}
                        setValue={(value: {id: string; name: string;}) => {
                            setSelectedParticipant(value);
                        }}
                        onInputChange={(_event: any, newInputValue: string) => {
                            setParticipantNameToSearch(newInputValue)
                        }}
                        inputValue={participantNameToSearch}
                        label={t("softwareManagement.modules.groups.participant")}
                    />
                </SelectContainer>

                <AddButton onClick={handleAddParticipant} type='button'  />
            </AddParticipantContainer>

            <ParticipantListContainer>
                {participants.map((participant) => (
                    <ParticipantBox key={participant.id}>
                        <ParticipantName>
                            {participant.name}
                        </ParticipantName>      

                        <ActionButtonsContainer>
                            <ParticipantLink href={`/system-management/configure-users?id=${participant.id}`} target="_blank">
                                <LinkTwoTone />
                            </ParticipantLink>
                            
                            <ActionButton onClick={() => handleRemoveParticipant(participant.id)}>
                                <Close />
                            </ActionButton>
                        </ActionButtonsContainer>
                    </ParticipantBox>        
                ))}
            </ParticipantListContainer>  
        </Container>
    );
}

export default ParticipantsCard;
